import React, { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useStyles } from './DropdownMenuPages.styles';
import { ReactComponent as Page } from '../../assets/icons/page.svg';
import { ReactComponent as PageActive } from '../../assets/icons/page-active.svg';
import { ReactComponent as PageDisabled } from '../../assets/icons/page-disabled.svg';
import { IconButton } from '@mui/material';
import CancelIcon from '@material-ui/icons/Cancel';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { fill, fillBlue, fillOpacity } from '../../utils/contrastSvgAttributes';
import { useLayoutContext } from '../../Context/Layout.context';

interface DropdownPagesProps {
  disabled?: boolean;
  handleViewMultiplePages: (option: number) => void;
}

const DropdownMenuPages: React.FC<DropdownPagesProps> = (props) => {
  const [anchorElPage, setAnchorElPage] = useState<HTMLButtonElement | null>(null);

  const { isAnyDropdownOpen } = useLayoutContext();

  const [active, setActive] = useState<boolean>(false);

  const classes = useStyles();

  const handleClickPageSelect = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setActive(true);
    setAnchorElPage(event.currentTarget);
    isAnyDropdownOpen.current = true;
  };

  const handleClosePageSelect = () => {
    setActive(false);
    setAnchorElPage(null);
    isAnyDropdownOpen.current = false;
  };

  return (
    <div>
      <TooltipOne title={'Ustaw liczbę widocznych stron'} placement="top">
        <IconButton onClick={!props.disabled ? handleClickPageSelect : undefined}>
          {props.disabled ? (
            <>
              <CancelIcon className={classes.disabledAction} />
              <PageDisabled
                className={classes.cardPreviewMenuIcon}
                fill={fill}
                fillOpacity={fillOpacity}
                style={{ cursor: props.disabled ? 'not-allowed' : undefined }}
              />
            </>
          ) : !active ? (
            <Page className={classes.cardPreviewMenuIcon} fill={fill} />
          ) : (
            <PageActive className={classes.cardPreviewMenuIcon} fill={fillBlue} />
          )}
        </IconButton>
      </TooltipOne>
      <Menu
        className={classes.pageSelectList}
        id="accountType-menu"
        anchorEl={anchorElPage}
        keepMounted
        open={Boolean(anchorElPage)}
        onClose={handleClosePageSelect}
      >
        <MenuItem
          disableRipple
          onClick={() => props.handleViewMultiplePages(1)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              props.handleViewMultiplePages(1);
            }
          }}
        >
          <Page className={classes.pageSelectMenuIcon} title="ikona jedna strona" /> 1 strona
        </MenuItem>
        <MenuItem
          disableRipple
          onClick={() => props.handleViewMultiplePages(2)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              props.handleViewMultiplePages(2);
            }
          }}
        >
          <div className={classes.pageSelectMenuIcon2}>
            <Page title="ikona dwie strony" />
            <Page title="ikona dwie strony" />{' '}
          </div>{' '}
          2 strony
        </MenuItem>
      </Menu>
    </div>
  );
};

export default DropdownMenuPages;
